import React from 'react';
import { getPolyglot } from '../../i18n';
import { Container, Typography, Stack, Box } from '@mui/material';
import NavBackButton from '../DeviceManager/navigations/NavBackButton';
import { useNavigate } from 'react-router-dom';
import Notifications from './Notifications';
import NotificationAPI from '../../redux/notifications/api/NotificationAPI';
import useWatchError from '../../handlingErrors/useWatchError';
import ButtonLoading from '../commons/ButtonLoading/ButtonLoading';
import Breadcrumb, {
  BreadcrumbSection,
} from '../../theme/components/Breadcrumb/Breadcrumb';

export function NotificationsPage() {
  const polyglot = getPolyglot();
  const [markAllNotificationAsReaded, { error, isLoading }] =
    NotificationAPI.useSetAllNotificationReadStatusMutation();

  useWatchError(error);

  const sectionsNavigation: BreadcrumbSection[] = [
    {
      content: polyglot.t('nav.menu.devicemanager'),
      href: '/devicemanager',
    },
    {
      content: polyglot.t('notifications.all_notifications_title'),
      href: '/notifications',
    },
  ];
  return (
    <Container
      maxWidth="xl"
      sx={{
        height: '100%',
        py: 1,
      }}
    >
      {sectionsNavigation.length > 1 && (
        <Box sx={{ mx: { xs: 1, md: 3 } }}>
          <Breadcrumb sections={sectionsNavigation} />
        </Box>
      )}
      <Typography variant="h1">
        {polyglot.t('notifications.all_notifications_title')}
      </Typography>

      <Container maxWidth="lg" disableGutters sx={{ paddingBottom: 2 }}>
        <Stack spacing={1}>
          <Stack direction={'row'} spacing={1} justifyContent={'flex-end'}>
            <ButtonLoading
              variant="contained"
              onClick={(e) => markAllNotificationAsReaded({ status: true })}
              loading={isLoading}
            >
              {polyglot.t('notifications.mark_all_as_read')}
            </ButtonLoading>
          </Stack>
          <Notifications />
        </Stack>
      </Container>
    </Container>
  );
}

export default NotificationsPage;
